import { useAppSelector } from '../../hooks/redux';
import { createGlobalStyle } from 'styled-components';
import { selectGlobalStylesheet } from '../../selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const Stylesheet = createGlobalStyle(props => props);
export const GlobalStyles = () => {
  const globalStylesheet = useAppSelector(selectGlobalStylesheet);
  return /*#__PURE__*/_jsx(Stylesheet, Object.assign({}, globalStylesheet));
};